import type { URLOpenListenerEvent } from "@capacitor/app";

export const parseAppLinkEvent = (
  event: URLOpenListenerEvent,
): string | null => {
  try {
    // Remove the hostname from the url
    const url = new URL(event?.url);
    const slug = url.pathname + url.search + url.hash;
    return slug || null;
  } catch (error) {
    console.error("Error parsing App Link event", error);
    return null;
  }
};
